import React, { useEffect, useState } from 'react';
import { Alert, IconButton, Paper, Tooltip } from '@mui/material';
import '../../../../resources/styling/App.scss';
import TagRow from './TagRow';
import tagService from '../../../../services/api/insights/tagService';
import InsightsLoader from '../../InsightsLoader';
import { Stack, textAlign } from '@mui/system';
import AddEditTag from './AddEditTag';
import { colors } from '../../../../resources/theme/colors';
import { Add, Merge } from '@mui/icons-material';
import { MergeTag } from './MergeTag';

const { mandy, pictonBlue } = colors;

export default function TagList({ selectedTag, setSelectedTag }) {
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddTag, setShowAddTag] = useState(false);
  const [showMergeTag, setShowMergeTag] = useState(false);

  const handleEdit = (newTag) => {
    setTags([...tags.map((tag) => (tag.id === newTag.id ? newTag : tag))]);
    setSelectedTag([...newTag]);
  };

  const handleDelete = (tag) => {
    const newTags = tags.filter((t) => t.id !== tag.id);
    setTags([...newTags]);
    setSelectedTag(null);
  };

  useEffect(() => {
    setLoading(true);
    tagService
      .getTags()
      .then((res) => {
        setTags(res.sort((x, y) => x.name.localeCompare(y.name)));
      })
      .finally(() => setLoading(false));
  }, []);

  const updateAfterMerge = (tag1, tag2, tag3) => {
    let newList = [...tags];
    newList = newList.filter((tag) => tag.id !== tag1.id && tag.id !== tag2.id);
    newList.push(tag3);
    setTags(newList);
    setSelectedTag(tag3);
  };

  const renderMergeTags = () =>
    showMergeTag && (
      <MergeTag
        tags={tags}
        closeModal={() => setShowMergeTag(false)}
        updateAfterMerge={updateAfterMerge}
      />
    );

  return (
    <div className='tag-list-container'>
      {renderMergeTags()}
      <div className='insight-heading'>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <div>Question Tags</div>
          <div>
            <Stack direction='row' gap={0.5} justifyContent='flex-end'>
              <IconButton
                size='small'
                style={{ backgroundColor: mandy, color: 'white' }}
                onClick={() => setShowMergeTag(true)}
              >
                <Tooltip title='Merge Tag' placement='top' arrow>
                  <Merge sx={{ fontSize: '20px' }}></Merge>
                </Tooltip>
              </IconButton>

              <IconButton
                size='small'
                style={{ backgroundColor: mandy, color: 'white' }}
                onClick={() => setShowAddTag(true)}
              >
                <Tooltip title='Add New Tag' placement='top' arrow>
                  <Add sx={{ fontSize: '20px' }}></Add>
                </Tooltip>
              </IconButton>
            </Stack>
            <AddEditTag
              selectedTag={null}
              editTagDone={(doneOrCancel, t) => {
                setShowAddTag(false);
                if (doneOrCancel === 'done') {
                  let tt = [...tags, t];
                  setTags([...tt]);
                  setSelectedTag(t);
                }
              }}
              mode='add'
              openEdit={showAddTag}
            />
          </div>
        </Stack>
      </div>
      <div className='taglist'>
        {loading ? (
          <InsightsLoader />
        ) : tags?.length > 0 ? (
          tags.map((tag) => (
            <TagRow
              tag={tag}
              selectedTag={selectedTag}
              setSelectedTag={setSelectedTag}
              updateListAfterEdit={handleEdit}
              UpdateListAfterDelete={handleDelete}
            />
          ))
        ) : (
          <Alert severity='info'>No tags found</Alert>
        )}
      </div>
    </div>
  );
}
